import {
  FormEnumFieldWidget,
  FormFieldWidget,
  ModelFieldType,
  RuntimeEnumerationOption,
  SPI,
  ViewType,
  Widget,
  http
} from '@kunlun/dependencies';
import { TIssuingMethod, useProxyDelivery } from '../../../../hooks';
import { Ref, toRef, toRaw } from 'vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Enum,
    model: ['deli.aries.seller.DeliAriesSellerPurchasingPlan'],
    name: 'ariesTmsDeliveryMethodEnum',
    multi: false
  })
)
@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Enum,
    model: [
      'deli.aries.seller.SellerDistributionCreateOrderParam',
      'deli.aries.seller.SellerDistributorAuditOrderParam'
    ],
    name: 'tmsDeliveryMethod',
    multi: false
  })
)
export class FormEnumDeliveryMethodFieldWidget extends FormEnumFieldWidget {
  public initialize(props) {
    super.initialize(props);
    // this.setComponent(ProxyDelivery);
    return this;
  }

  @Widget.Reactive()
  selectOptions: RuntimeEnumerationOption[] = [];

  @Widget.Reactive()
  protected get options(): RuntimeEnumerationOption[] {
    return this.selectOptions;
  }

  watchProxyMethod(key: string, value: string) {
    if (value) {
      const { pickerShippingType } = useProxyDelivery(toRef(this.formData, key) as Ref<TIssuingMethod>);
      this.selectOptions = pickerShippingType.value.filter(item=>toRaw(this.formData.deliveryMethods as any)?.includes(item.value))
      if (this.selectOptions.length>0 && this.selectOptions.every((option) => option.value !== this.value)) {
        this.setValue(this.selectOptions[0].value);
      }
    } else {
      this.selectOptions = [];
    }
  }
  
  @Widget.Watch('formData.sellerPartnerRelationApplySearch')
  protected watchSellerPartnerRelationApplySearch(value: string) {
    this.watchProxyMethod('ariesIssuingMethodEnum', value);
  }

  @Widget.Watch('formData.ariesIssuingMethodEnum')
  protected watchAriesIssuingMethodEnum(value: string) {
    this.watchProxyMethod('ariesIssuingMethodEnum', value);
  }

  // 要货计划字段：
  // 代发方式 issuingMethod
  @Widget.Watch('formData.issuingMethod')
  protected watchIssuingMethod(value: string) {
    this.watchProxyMethod('issuingMethod', value);
  }
  // 要货计划字段：
  // 代发方式 deliveryMethods
  @Widget.Watch('formData.deliveryMethods')
  protected watchDeliveryMethods(value: string) {
    this.watchProxyMethod('issuingMethod', value);
  }
}
